import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Button from '../../../../components/Button';
import Field from '../../../../components/Field';
import { REQUIRED, WRONG_PIN } from '../../../Taps/components/Forms/private/validation';

export default class CheckCertificatePassword extends Component {
  static propTypes = {
    checkPassword: PropTypes.func.isRequired,
    invalidStatus: PropTypes.any,
    removeCertificate: PropTypes.func.isRequired,
  };
  state = {
    password: '',
    isValid: true,
    validationMessage: '',
    isClickRemoving: false,
  };

  componentDidMount() {
    const { invalidStatus } = this.props;
    if (invalidStatus) {
      this.setInvalid();
    }
  }

  componentDidUpdate() {
    if (this.props.invalidStatus && this.state.isValid) {
      this.setInvalid();
    }
  }

  setInvalid = () => {
    this.setState({ isValid: false, validationMessage: WRONG_PIN });
  };

  getPasswordProps = () => {
    const { isValid, validationMessage, password } = this.state;
    return {
      isValid,
      validationMessage,
      value: password,
      label: 'Пароль доступа к сертификату',
      maxLength: 255,
      type: 'password',
      onChange: (e) =>
        this.setState({ password: e.target.value, isValid: true, validationMessage: '' }),
    };
  };

  validatePassword = () => {
    const { checkPassword } = this.props;
    const { password } = this.state;
    if (password) {
      this.setState({ isValid: true, validationMessage: '', password: '' });
      checkPassword(password);
    } else {
      this.setState({ isValid: false, validationMessage: REQUIRED });
    }
  };

  render() {
    const props = this.getPasswordProps();
    return this.state.isClickRemoving ? (
      this.props.removeCertificate()
    ) : (
      <div>
        <h2>Просмотр реквизитов сертификата</h2>
        <Field {...props} />
        <div className="link link_attention page_margin30 page_margin40">
          Если Вы забыли пароль, необходимо{' '}
          <a onClick={() => this.setState({ isClickRemoving: true })}>
            отозвать текущий сертификат
          </a>
          , после чего сформировать запрос на выпуск нового.
        </div>
        <div style={{ textAlign: 'right' }}>
          <Button onClick={() => this.validatePassword()} value="Далее" />
        </div>
      </div>
    );
  }
}
